export const inputCls =
  "w-full bg-white border border-[#e5e0d8] text-[#1c1a17] rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-[#234333] focus:border-[#234333]";

export const AREA_UNITS = ["sqft", "sqm", "acres", "hectares"];
export const OWNERSHIP_TYPES = ["Owned", "Leased"];
export const PROPERTY_TYPES = [
  "Building",
  "Hostel",
  "Workshop",
  "Shopping Complex",
  "Playground",
  "Other",
];
export const PROPERTY_USAGE = [
  "Academic",
  "Residential",
  "Commercial",
  "Common",
  "Other",
];
export const PROPERTY_CONDITION = [
  "New",
  "Good",
  "Fair",
  "Needs Repair",
  "Demolished",
];
export const ALLOCATION_TYPES = [
  "Institute Use",
  "Tenant Lease",
  "Common Use",
  "Vacant",
  "Other",
];

export function fmtNumber(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("en-IN");
}

export function buildMapHref(lat, lng, fallbackQuery) {
  if (lat && lng)
    return `https://www.google.com/maps?q=${encodeURIComponent(`${lat},${lng}`)}`;
  if (fallbackQuery)
    return `https://www.google.com/maps?q=${encodeURIComponent(fallbackQuery)}`;
  return null;
}
